import { checkResponse } from "./utils";
import { getToken } from "../utils/token";

const baseUrl = process.env.REACT_APP_API_URL || "http://localhost:3001";


export function request(url, options) {
  return fetch(url, options).then(checkResponse);
}

const getItems = () => {
  return request(`${baseUrl}/items/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const addItem = ({ name, weather, imageUrl }) => {
  const token = getToken();
  return request(`${baseUrl}/items/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      name: name,
      weather: weather,
      imageUrl: imageUrl,
    }),
  });
};

const addCardLike = (id) => {
  const token = getToken();

  return request(`${baseUrl}/items/${id}/likes`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const removeCardLike = (id) => {
  const token = getToken();

  return request(`${baseUrl}/items/${id}/likes`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const deleteItem = (id) => {
  const token = getToken();

  return request(`${baseUrl}/items/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const getUserInfo = () => {
  const token = getToken();

  return request(`${baseUrl}/users/me`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const editProfile = (data) => {
  const token = getToken();
  return request(`${baseUrl}/users/me`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  });
};

const getFavorites = () => {
  const token = getToken();

  return request(`${baseUrl}/favorites/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const addFavorite = ({ type, url, title }) => {
  const token = getToken();

  return request(`${baseUrl}/favorites/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ type, url, title }),
  });
};

const deleteFavorite = (id) => {
  const token = getToken();

  return request(`${baseUrl}/favorites/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const getGalleryItems = () => {
  const token = getToken();

  return request(`${baseUrl}/gallery/`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const addGalleryLink = ({ kind, url, title }) => {
  const token = getToken();

  return request(`${baseUrl}/gallery/link`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ kind, url, title }),
  });
};

// Uses FormData, so no Content-Type header is set here on purpose — the
// browser sets it automatically with the correct multipart boundary. Adding
// one manually would break the upload.
const uploadGalleryFile = (file, title) => {
  const token = getToken();
  const formData = new FormData();
  formData.append("file", file);
  if (title) {
    formData.append("title", title);
  }

  return request(`${baseUrl}/gallery/upload`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData,
  });
};

const deleteGalleryItem = (id) => {
  const token = getToken();

  return request(`${baseUrl}/gallery/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
};

const api = {
  getItems,
  addItem,
  deleteItem,
  addCardLike,
  removeCardLike,
  getUserInfo,
  editProfile,
  getFavorites,
  addFavorite,
  deleteFavorite,
  getGalleryItems,
  addGalleryLink,
  uploadGalleryFile,
  deleteGalleryItem,
};

export default api;
